// style imports
import './CheckField.css';

const CheckField = ({ name, onchange, label, value }) => {
  // handle onchange event
  const handleOnchange = (e) => {    
    if (onchange) {
      onchange(e.target.checked)
    }
  }
  return (
    <div className='mues_row_flex mues_column_gap_4
    radio_container mues_pointer'>
      <input type="checkbox" name={name} id={name}
      onChange={handleOnchange} checked={value} />
      <label className='mues_pointer' htmlFor={name}>{label}</label>
    </div>
  )
}

export default CheckField